/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdStepperProps } from './type';

export const stepperDefaultProps: TdStepperProps = {
  disableInput: false,
  disabled: undefined,
  integer: true,
  max: 100,
  min: 0,
  size: 'medium',
  step: 1,
  theme: 'normal',
  defaultValue: 0,
};
